module.exports = __webpack_public_path__ + "static/media/Condessa.bc6b5486.png";